import { biToast } from '@pulsepointinc/bi-components';
import { DownloadError, safeDownloadFromUrl } from '../helpers';
import type { GetTaskStatusResponse } from '../lib/api/tasks/dto';
import { type ReportTask, useReportTasksStore } from '../stores/reportTasks';
import { useTaskPolling } from './useTaskPolling';

const handleReportCompletion = async (
  data: GetTaskStatusResponse,
  task: ReportTask,
  removeTask: (id: string) => void,
) => {
  if ('error' in data) {
    removeTask(task.taskId);
    biToast.error(data.errorDesc || data.error || 'Report generation failed');
    return;
  }

  const { taskDetails } = data;
  const { response, status } = taskDetails || {};
  const { files } = response || {};

  const filename = task.deliveryName || task.taskId;

  if (status === 'completed') {
    removeTask(task.taskId);
    if (files?.length) {
      try {
        await safeDownloadFromUrl(files[0], filename);
        biToast.success('Report downloaded successfully');
      } catch (error) {
        if (error instanceof DownloadError) {
          //TODO: Show toast with download button here
          biToast.error('Could not download report');
        } else {
          biToast.error('Could not download report');
        }
      }
    }
  } else if (status === 'failed') {
    removeTask(task.taskId);
    biToast.error('Report generation failed');
  }
};

export const useReportPolling = () => {
  const activeTasks = useReportTasksStore((state) => state.activeTasks);
  const removeTask = useReportTasksStore((state) => state.removeTask);

  useTaskPolling({
    activeTasks,
    removeTask,
    queryKeyPrefix: 'reportStatus',
    timeoutMessage: 'Report generation timed out. Please try again.',
    onComplete: handleReportCompletion,
  });
};
